// Copy to clipboard
async function copyToClipboard(text, element) {
	try {
		await navigator.clipboard.writeText(text);

		element.classList.add('--success');
		element.querySelector('span').innerText = element.dataset.message;

		setTimeout( function() {
			element.classList.remove('--success');
			element.querySelector('span').innerText = element.dataset.label;
		}, 5000);

	  } catch (err) {
		console.error('Failed to copy: ', err);
	  }
}

document.addEventListener('DOMContentLoaded', e => {
	document.querySelectorAll('.share-button').forEach( i => {
		i.addEventListener('click', evt => {
			let btn = evt.target.closest('.button');
			
			copyToClipboard(btn.dataset.url, btn);
		});
	});
});